exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.non-legacy-invoices-modal__overlay[data-v-846a6778] {\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  z-index: 20;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.non-legacy-invoices-modal__container[data-v-846a6778] {\n  width: 40rem;\n  max-height: 90%;\n  max-width: 100%;\n  overflow-y: auto;\n  border-radius: 0.25rem;\n  position: relative;\n}\n.non-legacy-invoices-modal__divider[data-v-846a6778] {\n  border-top: 0.0625rem solid #c5d0de;\n  margin: 1rem 0;\n}\n.non-legacy-invoices-modal__body[data-v-846a6778] {\n  min-height: 12rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-846a6778","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEditV2/TabPayments/NonLegacyInvoicesModal.vue
// module id = 1980
// module chunks = 0